module.exports = __webpack_public_path__ + "static/media/Event_type.6b31bf66.gif";